module.exports = __webpack_public_path__ + "static/media/a1.865cc36f.jpg";